import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      fetching: {
        areaManagersActivities: false
      },
      options: {
        areaManagersActivities: []
      },
      selected: {
        activityType: '',
        areaManagersActivity: '',
        schedule: ''
      },
      editable: {
        areaManagersActivity: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUserRole: 'auth/user'
    })
  },

  methods: {

    async getAreaManagerActivities (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.areaManagersActivity
      const fetching = context.fetching?.areaManagersActivities
      const options = context.options?.areaManagersActivities
      const activityType = context.selected?.activityType
      const selectedSchedule = context.selected?.schedule

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options) || nullOrUndefined(selectedSchedule) || nullOrUndefined(activityType)) {
        throw Error('Invalid context object')
      }

      context.fetching.areaManagersActivities = true
      context.selected.areaManagersActivity = ''

      const filters = {
        filter_text: search,
        activity_type: context.selected?.activityType || '',
        schedule: context.selected?.schedule || '',
        role_id: 3
      }

      return await SSharedList.getActivities(filters).then(
        ({ data }) => {
          context.options.areaManagersActivities = data
        }
      ).catch(() => {
        context.options.areaManagersActivities = []
      }).finally(() => {
        context.fetching.areaManagersActivities = false
      })
    },

    async searchAreaManagerActivities (search, loading) {
      this.searchAreaManagerActivitiesProvider(this, search, loading)
    },

    searchAreaManagerActivitiesProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.areaManagersActivities, {
          keys: ['activity_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            schedule: selected?.schedule || '',
            role_id: 3
          }

          SSharedList.getActivities(filters).then(
            ({ data }) => {
              options.areaManagersActivities = data
            }
          ).catch(() => {
            options.areaManagersActivities = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
